import React, { useState, useEffect } from 'react';

const ToggleSwitch = ({ label, initial = false }) => {
    const [isToggled, setIsToggled] = useState(initial);

    useEffect(() => {
        setIsToggled(initial);
    }, [initial]);

    const handleToggle = () => {
        setIsToggled(!isToggled);
    };

    return (
        <span className='flex items-center gap-5 ' onClick={handleToggle}>
            <div
                className={`relative sm:w-16 w-20 h-8 flex items-center bg-gray-600 rounded-full p-1 cursor-pointer transition-colors duration-300 ease-in-out ${isToggled ? 'bg-primary-800' : ''
                    }`}
            >
                <div
                    className={`bg-white w-6 h-6 rounded-full shadow-md transform transition-transform duration-300 ease-in-out ${isToggled ? 'sm:translate-x-8 translate-x-7' : ''
                        }`}
                ></div>
            </div>

            <div>
                {label && <span className="text-dark">{label}</span>}
            </div>
        </span>
    );
};

export default ToggleSwitch;
